import { render, staticRenderFns } from "./complainDialog.vue?vue&type=template&id=7fb7ddf8&scoped=true"
import script from "./complainDialog.vue?vue&type=script&lang=js"
export * from "./complainDialog.vue?vue&type=script&lang=js"
import style0 from "./complainDialog.vue?vue&type=style&index=0&id=7fb7ddf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7ddf8",
  null
  
)

export default component.exports